<template>
  <div class="h-full flex flex-col" v-loading="saveLoading">
    <div>
      <el-page-header @back="$emit('cancel')" content="导出风险应知卡"></el-page-header>
    </div>
    <div class="flex-1 overflow-y-auto mt-20px mx-200px">
      <div class="pdf-panel px-10px" ref="card">
        <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
          {{ displayName }}企业风险应知卡
        </div>
        <el-card class="custom-card" shadow="never">
          <div slot="header" class="text-sm font-bold p-10px bg-color-primary">
            风险点基本信息
          </div>
          <div class="table-form border-1 border-color-default">
            <table class="table-body w-full">
              <tbody class="text-sm text-left">
                <tr class="border-b-1 border-color-default">
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">
                      风险点类型
                    </div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">设备设施名称</div>
                  </td>

                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">风险等级</div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">管控层级</div>
                  </td>
                </tr>
                <tr class="border-b-1 border-color-default">
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="font-bold">{{ cardDetail.riskPointType }}</div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ cardDetail.equipmentFacilityName }}
                    </div>
                  </td>

                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="font-bold">
                      {{ cardDetail.evaluationLevel }}
                    </div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ cardDetail.controlLevel }}
                    </div>
                  </td>
                </tr>
                <tr class="border-b-1 border-color-default">
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">设备编码</div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">所在区域</div>
                  </td>

                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">责任部门</div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold">责任人</div>
                  </td>
                </tr>
                <tr class="border-b-1 border-color-default">
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="font-bold">{{ cardDetail.equipmentFacilityNo }}</div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ cardDetail.equipmentFacilityAreaStr }}
                    </div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="font-bold">{{ cardDetail.organizationUnitName }}</div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ cardDetail.leaderName }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
        <el-card class="custom-card" shadow="never">
          <div slot="header" class="text-sm font-bold p-10px bg-color-primary">
            主要危险有害因素
          </div>
          <div class="table-form border-1 border-color-default">
            <table class="table-body w-full">
              <tbody class="text-sm text-left">
                <tr class="border-b-1 border-color-default">
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">检查项目</div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">检查标准</div>
                  </td>

                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">不符合标准情况</div>
                  </td>
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">主要后果</div>
                  </td>
                </tr>
                <tr
                  v-for="(item,
                  index) in cardDetail.equipmentFacilitySourcesDangerIdentifyAssessDtos"
                  :key="index"
                  class="border-b-1 border-color-default"
                >
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">{{ item.projectName }}</div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ item.standard }}
                    </div>
                  </td>

                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ item.noComplianceStandard }}
                    </div>
                  </td>
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">
                      {{ item.consequences }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
        <el-card class="custom-card" shadow="never">
          <div slot="header" class="text-sm font-bold p-10px bg-color-primary">
            主要管控措施
          </div>
          <div class="table-form border-1 border-color-default">
            <table class="table-body w-full">
              <tbody class="text-sm text-left">
                <tr class="border-b-1 border-color-default">
                  <td
                    class="bg-table-header w-1/4 border-r-1 border-color-default p-10px table-cell"
                  >
                    <div class="font-bold text-color-primary">管控措施</div>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in controlData"
                  :key="index"
                  class="border-b-1 border-color-default"
                >
                  <td class="w-1/4 border-r-1 border-color-default p-10px table-cell">
                    <div class="text-color-primary font-normal">{{ item.controls }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
        <el-card shadow="never">
          <div class="w-full p-10px bg-color-primary">
            <el-row :gutter="10" type="flex" justify="space-between" align="center">
              <el-col :span="10" class="flex justify-center items-center">
                <div class="w-150px text-right text-sm font-bold">
                  值班电话：
                </div>
                <el-input class="flex-1" disabled v-model="cardDetail.dutyPhone"></el-input>
              </el-col>
              <el-col :span="10" class="flex justify-center items-center">
                <div class="w-150px text-right text-sm font-bold">
                  应急电话：
                </div>
                <el-input class="flex-1" disabled v-model="cardDetail.emergencyPhone"></el-input>
              </el-col>
              <!-- TODOS:后续开发 -->
              <!-- <el-col :span="4" class="flex justify-center items-center">
                <el-image class="w-25 h-25" src="@/assets/images/home-bg.jpg"></el-image>
              </el-col> -->
            </el-row>
          </div>
        </el-card>
      </div>
    </div>
    <div class="flex justify-center mt-20px">
      <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >导出</el-button
      >
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import html2pdf from '@/components/safety/enumField/pdfPage'
import { OrganizationApi } from '@wiz-api/account'

const organizationApi = new OrganizationApi()

export default {
  name: 'bank-risk-card',
  components: {},
  props: {
    cardDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      displayName: '',
      ruleForm: {},
      saveLoading: false,
      collapseActiveName: ['baseInfo', 'risk', 'evaluate', 'control'],
      tableData: [],
      controlData: [
        {
          controls: '',
        },
      ],
    }
  },
  created() {
    this.getTelantInfo()
    const controls = []
    _.forEach(this.cardDetail.equipmentFacilitySourcesDangerIdentifyAssessDtos, (item, index) => {
      _.forEach(item.sourcesDangerRecognitionRiskAssessControlDtos, (ele, eIndex) => {
        controls.push(ele.existingControlMehtod)
      })
    })

    this.controlData[0].controls = _.map(controls, (ele, eIndex) => {
      return `${eIndex + 1}、${ele}`
    }).join('')
  },
  methods: {
    // 获取企业信息
    async getTelantInfo() {
      this.saveLoading = true
      const [err, res] = await organizationApi.getAllListDetails()
      if (!err) {
        this.displayName = res.items[0]?.displayName
      }
      this.saveLoading = false
    },
    // 导出pdf
    exportRiskCard() {
      const pdfName = `${this.displayName}企业风险应知卡`
      html2pdf(this.$refs.card, pdfName)
    },
  },
}
</script>

<style scoped lang="scss">
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }
}

::v-deep .el-card .el-card__header {
  padding: 10px;
}

::v-deep .custom-card {
  border-bottom: none !important;
}

::v-deep .el-card .el-card__header {
  padding: 0 !important;
}
</style>
